// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1GT0K-","heading":"_3MxXj-"};